"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SubscriptionInfo = require("./SubscriptionInfo");
Object.keys(_SubscriptionInfo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SubscriptionInfo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SubscriptionInfo[key];
    }
  });
});
